import {
    LiteTradePortfolioItemProgressStyled,
    LiteTradePortfolioListItemStyled
} from "./styled/LiteTradePortfolioStyled.js";
import { IconAsset } from "../../../../components/icon/Icon.jsx";
import { memo, useMemo } from "react";
import { createStructuredSelector } from "reselect";
import { getLiteTradeMarketData } from "../../liteTradeSelectors";
import { connect } from "react-redux";
import { LITE_TRADE_POSITION_SIDE } from "../../liteTradeConstants.js";
import LiteTradePortfolioOrderInfo from "./LiteTradePortfolioOrderInfo.jsx";
import classNames from "classnames";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";

const LiteTradePortfolioOrderRow = memo(({item, marketData, from}) => {
    const {getLangPath} = useLangContext();
    const pipsLeft = useMemo(() => {
        if (!marketData[item.instrument]) {
            return null;
        }
        const currentPrice = item.side === LITE_TRADE_POSITION_SIDE.BUY ? marketData[item.instrument].ask : marketData[item.instrument].bid;
        return Math.round(Math.abs(item.legs[0].price - currentPrice) / item.assetInstance.getPipSize());
    }, [item, marketData]);

    const leftProgress = useMemo(() => {
        if (!pipsLeft) {
            return 0;
        }
        return Math.max(100 - Math.pow(pipsLeft, 0.66), 3);
    }, [pipsLeft]);

    return <>
        <LiteTradePortfolioListItemStyled className={classNames({
            'inactive': !item.assetInstance.isTradingNow()
        })}>
            <div className="col-left"><IconAsset symbol={item.instrument}/></div>
            <div className="col-center">
                <div className={'d-flex justify-content-between'}>
                    <div className={'pb-2'}>
                        <div className={'f16'}>{item.assetInstance.asset.info.description}</div>
                        <div className={'asset-row-info f14 fw600 color-white-60'}>
                            <LiteTradePortfolioOrderInfo
                                item={item}
                                hideSymbol={from !== 'portfolio'}
                            />
                        </div>
                    </div>
                    <div className="col-right">
                        <div className={'f16 fw600'}>{pipsLeft}</div>
                        <div className={'fw400 color-white-60'}>{getLangPath('lite_version.portfolio.order_pips_left')}</div>
                    </div>
                </div>
                <LiteTradePortfolioItemProgressStyled className={'progress'} progress={leftProgress}/>
            </div>
        </LiteTradePortfolioListItemStyled>
    </>
});

const mapStateToProps = createStructuredSelector({
    marketData: getLiteTradeMarketData,
});

export default connect(mapStateToProps)(LiteTradePortfolioOrderRow);
